import { render, staticRenderFns } from "./CompanyDesktopMultiOrder.vue?vue&type=template&id=263933c0"
import script from "./CompanyDesktopMultiOrder.vue?vue&type=script&lang=js"
export * from "./CompanyDesktopMultiOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports